import verifyIsLoginActive from 'util/verifyIsLoginActive'
import jwt from 'jwt-decode'
import axios from 'shared/http'

const redirectToExternalLink = async (redirectTO, page, target, options) => {
  const webpremios = async () => {
    const data = { path: '' }
    let url = '/participants/v1/session-marketplace'
    await axios
      .post(url, data)
      .then((response) => {
        window.open(response, target)
      })
      .catch((error) => {
        console.log(error)
      })
  }
  const shophub = async () => {
    let url = `/shopping/v1/redirect`
    const authToken = JSON.parse(localStorage.getItem('auth-token'))
    const user = jwt(authToken.accessToken)

    const data = {
      participant: user.marketplaceParticipantId,
      participantDocument: user.participantDocument,
    }

    await axios
      .post(url, data)
      .then((response) => {
        window.location = response
      })
      .catch((error) => {
        console.log(error)
      })
  }
  const beflyconecta = async () => {
    let url = `/catalog/v1/redirect/befly`
    try {
      const response = await axios.get(url)
      const urlMkp = response
      window.location.href = urlMkp
      // window.open(urlMkp, target ? target : '_self')
      localStorage.removeItem('be-fly')
    } catch (error) {
      console.error(error)
    }
  }

  const marketPlaceRedirect = async () => {
    const data = { path: '' }
    const url = `/participants/v1/session-marketplace`

    try {
      const response = await axios.post(url, data)
      window.location.href = response
    } catch (error) {
      console.log('File: redirectTo > marketPlaceRedirect', error)
      throw error
    }
  }

  let isLoginActive = verifyIsLoginActive()
  if (Boolean(isLoginActive)) {
    switch (redirectTO) {
      case 'webpremios':
        return webpremios()
      case 'shophub':
        return shophub()
      case 'beflyconecta':
        return beflyconecta()
      case 'market':
        return marketPlaceRedirect()
    }
  }
}

export default redirectToExternalLink
